import { createFileRoute } from '@tanstack/react-router'

import {
  useFetchChecks,
  useFetchInsights,
  useFetchProject,
  useFetchTransactions,
} from '@/modules/projects'
import { ProjectOverviewPage } from '@/modules/projects/pages'

export const Route = createFileRoute('/_authenticated/projects/$slug/')({
  component: ProjectOverview,
  errorComponent: ({ error }) => (
    <div className="p-4 text-red-500">Error: {error.message}</div>
  ),
  validateSearch: (search: Record<string, unknown>) => {
    const result: Record<string, string | number | undefined> = {
      page: search.page ? Number(search.page) : undefined,
      perPage: search.perPage ? Number(search.perPage) : undefined,
    }
    return result
  },
})

function ProjectOverview() {
  const { slug } = Route.useParams()
  useFetchProject(slug)
  useFetchTransactions(slug)
  useFetchChecks(slug)
  useFetchInsights(slug)

  return <ProjectOverviewPage slug={slug} />
}
